module.exports = __webpack_public_path__ + "static/media/img15.845c5641.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/img15.png
// module id = 136
// module chunks = 0